import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6fac8ecd"
var script = {}
import style0 from "./assets/tailwind.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=6fac8ecd&prod&lang=css"
import style2 from "./App.vue?vue&type=style&index=2&id=6fac8ecd&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports